import axios from 'axios';

export async function isComplianceDocumentReadyForDownload(campaignId, open) {
  const entity = open ? 'open' : 'campaigns';
  const response = await axios.post(`/api/?entity=${entity}&action=isComplianceDocumentReadyForDownload`, {campaignId});
  return response && response.data && response.data.data;
}
